module.exports = __webpack_public_path__ + "static/media/md.c6c921cf.svg";